import React from "react";
import { FiAlertCircle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import {
  AlertBadge,
  AtalhosGroup,
  AtalhosGroupTitle,
  AtalhosSection,
  PainelCard,
  PainelCardBottleneck,
  PainelGargaloFlag,
  PainelGrid,
  PainelIcon,
  PainelInfo,
  PainelLabel,
  PainelTotal,
} from "./styles";
import { groupAtalhos, isPainelDaEtapa } from "./helpers";

export default function AtalhosPorEtapa({ paineis, gargaloEtapa, calibracaoCompleta }) {
  const navigate = useNavigate();
  const grupos = groupAtalhos(paineis);

  return (
    <AtalhosSection>
      {grupos.map((grupo) => (
        <AtalhosGroup key={grupo.titulo}>
          <AtalhosGroupTitle>{grupo.titulo}</AtalhosGroupTitle>
          <PainelGrid>
            {grupo.paineis.map((painel) => {
              const Icon = painel.icon;
              const isGargalo =
                calibracaoCompleta && isPainelDaEtapa(painel.id, gargaloEtapa);
              const Card = isGargalo ? PainelCardBottleneck : PainelCard;
              return (
                <Card
                  key={painel.id}
                  type="button"
                  onClick={() => navigate(painel.rota)}
                  $hasAlert={painel.atrasados > 0}
                  whileHover={{ y: -3 }}
                  whileTap={{ scale: 0.98 }}
                  transition={{ duration: 0.15 }}
                >
                  {isGargalo && <PainelGargaloFlag>Gargalo</PainelGargaloFlag>}
                  <PainelIcon>
                    <Icon size={22} />
                  </PainelIcon>
                  <PainelInfo>
                    <PainelLabel>{painel.label}</PainelLabel>
                    <PainelTotal>
                      {painel.total} ambiente{painel.total !== 1 ? "s" : ""}
                    </PainelTotal>
                    <AlertBadge $active={painel.atrasados > 0}>
                      <FiAlertCircle size={13} />
                      {painel.atrasados} atraso{painel.atrasados !== 1 ? "s" : ""}
                    </AlertBadge>
                  </PainelInfo>
                </Card>
              );
            })}
          </PainelGrid>
        </AtalhosGroup>
      ))}
    </AtalhosSection>
  );
}
